import React from 'react';
import StaticPageLayout from '../components/StaticPageLayout';
import { CheckCircle } from 'lucide-react';

const PublicationEthicsPage = () => (
  <StaticPageLayout
    overline="Publication Ethics"
    title="Publication Ethics Policy"
    description="The institute follows a strong ethics-driven publication framework aligned with global best practices. This policy applies to all parties involved in the publication process."
    breadcrumbs={[{ label: 'Publication Ethics', path: '/publication-ethics' }]}
  >
    <div className="space-y-10">
      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-4 pb-3 border-b border-[#E5E7EB]">Our Commitment</h2>
        <p className="text-[#4B5563] leading-relaxed mb-4">
          The institute follows a strong ethics-driven publication framework aligned with global best practices in scholarly publishing. All authors, reviewers, editors, and staff are expected to uphold the highest standards of research and publication integrity.
        </p>
        <p className="text-[#4B5563] leading-relaxed">
          Our ethics framework is aligned with the principles established by the Committee on Publication Ethics (COPE) and other internationally recognised scholarly publishing standards bodies.
        </p>
      </section>

      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-5 pb-3 border-b border-[#E5E7EB]">Authorship Standards</h2>
        <p className="text-[#4B5563] leading-relaxed mb-4">
          Authorship must reflect genuine intellectual contribution. All listed authors must have materially contributed to the research design, execution, analysis, or interpretation, and must have approved the final submitted version.
        </p>
        <ul className="space-y-2">
          {[
            'Gift authorship (including individuals who did not contribute) is strictly prohibited',
            'Ghost authorship (excluding individuals who contributed) is not permitted',
            'All changes to authorship after submission must be approved by all co-authors and the editorial office',
          ].map(item => (
            <li key={item} className="flex items-start gap-2 text-sm text-[#4B5563]">
              <CheckCircle size={14} className="text-[#1A73E8] mt-0.5 flex-shrink-0" />{item}
            </li>
          ))}
        </ul>
      </section>

      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-4 pb-3 border-b border-[#E5E7EB]">Data Integrity</h2>
        <p className="text-[#4B5563] leading-relaxed">
          All reported data must be accurately and completely presented. Fabrication, falsification, selective omission of data, or inappropriate image manipulation constitutes research misconduct. Where data supporting the published findings are requested, authors are expected to cooperate with the editorial office.
        </p>
      </section>

      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-4 pb-3 border-b border-[#E5E7EB]">Handling Misconduct</h2>
        <p className="text-[#4B5563] leading-relaxed mb-3">
          Concerns about research or publication misconduct may be submitted to the editorial office. All reports are handled confidentially and investigated in accordance with established protocols. Possible outcomes include rejection, retraction, or formal reporting to the relevant institution.
        </p>
        <p className="text-[#4B5563] leading-relaxed">
          Post-publication corrections, expressions of concern, or retractions will be issued transparently where warranted.
        </p>
      </section>
    </div>
  </StaticPageLayout>
);

export default PublicationEthicsPage;
